import { cityParser } from "@/plugins/city_parser";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class SuperCategoriesScrollMenu extends Vue {
  @Prop({ default: () => [] }) superCategories;
  @Prop({ default: null }) currentId;
  @Prop({ default: false }) isRecentsView;
  @Prop({ default: true }) isLoading;

  @Getter getIsUnderMobile;
  @Getter getIsToken;
  @Getter getCity

  currentPosition = -1;
  maxPosition = 0;
  currentIndex = null;

  hideRightButton = false;
  hideLeftButton = false;

  @Watch("currentPosition")
  get isNextButtonHidden() {
    if (this.currentPosition + 5 >= this.maxPosition) {
      return true;
    } else {
      return false;
    }
  }

  get isPreviousButtonHidden() {
    if (this.currentPosition === 0) {
      return true;
    } else {
      return false;
    }
  }

   setCurrentIndex() {
    let res = -1;
    for(let i = 0; i < this.superCategories.length && res === -1; i++) {
      if(this.superCategories[i].id === this.currentId) {
        res = i;
      }
    }
    if(res < 0) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = res;
    }
  }

  mounted() {
    this.setCurrentIndex();
    this.$nextTick(() => {
      this.setPosition();
    });
  }

  @Watch("currentPosition")
  setMaxPosition() {
    if (
      document.querySelector(".inner") &&
      document.querySelector(".inner").scrollWidth &&
      document.querySelector(".inner").clientWidth
    ) {
      let tmpMaxPosition =
        document.querySelector(".inner").scrollWidth - document.querySelector(".inner").clientWidth;
      if (tmpMaxPosition > this.maxPosition) {
        this.maxPosition = tmpMaxPosition;
      }
    }
  }

  @Watch("currentIndex")
  setPosition() {
    let content = document.querySelector(".inner");
    if (this.currentIndex === 0) {
      content.scrollLeft = 0;
    } else if (this.currentIndex === this.superCategories.length - 1) {
      this.$nextTick(() => {
        content.scrollLeft = this.maxPosition + 100;
      });
    } else {
      content.scrollLeft = this.currentIndex * 95;
    }
    this.currentPosition = content.scrollLeft;
  }

  isCurrentIndex(index) {
    return index === this.currentIndex;
  }

  onClickSuperCategory(index) {
    this.currentIndex = index;
    this.$emit("updateSuperCategory", this.superCategories[index]);
  }

  scrollLeft(delta = 1) {
    let content = document.querySelector(".inner");
    content.scrollLeft -= 110 * delta;
    this.currentPosition = content.scrollLeft;
  }

  scrollRight(delta = 1) {
    let content = document.querySelector(".inner");
    content.scrollLeft += 110 * delta;
    this.currentPosition = content.scrollLeft;
  }

  onClickForYouButton() {
    if(this.$route && this.$route.name && this.$route.name !== 'forYou') {
      const cityId = cityParser(this.getCity.commercial_name);
      this.$router.replace({ name: 'forYou', params: { city_id: cityId }});
    }
  }
}
